module.exports = __webpack_public_path__ + "img/ESR.51ee470b.png";